import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env-properties/environment';
// import { ENGLISH_LANG } from '@mainrepo/app/core/constants/ENGLISH';
import { LoggerService } from './logger.service';
import { UniversalService } from './universal.service';

@Injectable({
  providedIn: 'root'
})
export class LandingService {

  private pageScreen: string;
  private apiUrl: string;
  public landingPageData;
  public isDarkTheme;
  public isMobileDevice: boolean = false;
  public isAnimationOn: boolean = true;
  public whatsNewData;
  public showWhatsNewPage = false;
  constructor(private http: HttpClient,public universalService:UniversalService,public loggerService:LoggerService) { 
    
  }

  public getLocalisationContent(pageType) {
    let classRef = this;
    return new Promise(function (resolve, reject) {
      classRef.http.get(classRef.getUrl(pageType)).subscribe(resp => {
        resolve(resp);
      }, err => {
        reject(err);
      });
    });
  }

  public getWhatsNewPageText(){
    let classRef = this;
    var url = '/assets/templates/landing/' + '/features/' + this.universalService.lang + '.json?v=47';

    return new Promise(function (resolve, reject) {
      setTimeout(function(){
        classRef.http.get(url).subscribe(resp => {
          // this.loggerService.log("inside get localisationContent response",resp)
          classRef.whatsNewData = resp;
          
          resolve(resp);
        }, err => {
          reject(err);
        });
      });
    });
  }

  private getUrl(pageType) {
    if (this.universalService.lang) {
      this.apiUrl = '/assets/templates/landing/' + pageType + '/' + this.universalService.lang + '.json' + "?av=" + environment.appVersion;
    }
    return this.apiUrl;
  }

  highlightSelectedElement(e, selectorItemClass, highlightClass) {
    jQuery(selectorItemClass).removeClass(highlightClass);
    jQuery(e.currentTarget).addClass(highlightClass);
  }
}
